const TIPOS_ESTADO_DESCARGA = [
  { 
    id: -3,
    Nombre: 'Error temporal',
    TipoEstadoFlujo: 'Vigilancia',
  },
  { 
    id: -2,
    Nombre: 'Expiradas',
    SalidaRegla: 'Vigilancia',
    TipoEstadoFlujo: 'Vigilancia',
  },
  { 
    id: -1,
    Nombre: 'En error',
    TipoEstadoFlujo: 'Vigilancia',
  },
  { 
    id: 0,
    Nombre: 'Puestas a disposición',
    SalidaRegla: 'Vigilancia',
    TipoEstadoFlujo: 'Vigilancia',
  },
  { 
    id: 1,
    Nombre: 'Orden de descarga',
    SalidaRegla: 'Vigilancia',
    TipoEstadoFlujo: 'Vigilancia',
    FlujoSinDestino: true,
  },
  { 
    id: 2,
    Nombre: 'Descargadas',
    SalidaRegla: 'Descarga',
    TipoEstadoFlujo: 'Descarga',
  },
  { 
    id: 3,
    Nombre: 'Esperando datos',
    TipoEstadoFlujo: 'Vigilancia',
    FlujoSalidaoDeshabilitado: true,
    FlujoSinDestino: true,
  },
  { 
    id: 4,
    Nombre: 'Petición fuera de horas',
    TipoEstadoFlujo: 'Vigilancia',
    FlujoSalidaoDeshabilitado: true,
    FlujoSinDestino: true,
  },
  { 
    id: 6,
    Nombre: 'No descargables',
    SalidaRegla: 'Vigilancia',
    TipoEstadoFlujo: 'Vigilancia',
  },
  { 
    id: 7,
    Nombre: 'Tramitadas',
    SalidaRegla: 'Descarga',
    TipoEstadoFlujo: 'Descarga',
  },
  { 
    id: 9,
    Nombre: 'Última llamada',
    SalidaRegla: 'Vigilancia',
    TipoEstadoFlujo: 'Vigilancia',
  },
  { 
    id: 10,
    Nombre: 'Tramitación urgente',
    SalidaRegla: 'Descarga',
    TipoEstadoFlujo: 'Descarga',
  },
  { 
    id: 11,
    Nombre: 'Reabiertas',
    TipoEstadoFlujo: 'Descarga',
  },
  { 
    id: 13,
    Nombre: 'Descarga externa',
    SalidaRegla: 'Descarga',
    TipoEstadoFlujo: 'Descarga',
  },
  { 
    id: 14,
    Nombre: 'Expiradas archivadas',
    SalidaRegla: 'Vigilancia',
    TipoEstadoFlujo: 'Vigilancia',
  },
  { 
    id: 15,
    Nombre: 'No descargables archivadas',
    SalidaRegla: 'Vigilancia',
    TipoEstadoFlujo: 'Vigilancia',
  },
  { 
    id: 16,
    Nombre: 'Archivadas sin descargar',
    SalidaRegla: 'Vigilancia',
    TipoEstadoFlujo: 'Vigilancia',
  },
  { 
    id: 17,
    Nombre: 'Esperando horario de descarga',
    SalidaRegla: 'Vigilancia',
    TipoEstadoFlujo: 'Vigilancia',
  },
  { 
    id: 18,
    Nombre: 'Trámite expirado',
    SalidaRegla: 'Descarga',
    TipoEstadoFlujo: 'Descarga',
  },
  { 
    id: 19,
    Nombre: 'Transferidas PaD',
    SalidaRegla: 'Vigilancia',
    TipoEstadoFlujo: 'Vigilancia',
  },
  { 
    id: 20,
    Nombre: 'Transferidas descargadas',
    SalidaRegla: 'Descarga',
    TipoEstadoFlujo: 'Descarga',
  },
  { 
    id: 21,
    Nombre: 'Rechazadas',
    SalidaRegla: 'Descarga',
    Modulo: 28,
    TipoEstadoFlujo: 'Descarga',
  },
  { 
    id: 22,
    Nombre: 'Urgente de aceptación',
    SalidaRegla: 'Descarga',
    Modulo: 28,
    TipoEstadoFlujo: 'Descarga',
  },
  { 
    id: 23,
    Nombre: 'No atentida',
    SalidaRegla: 'Descarga',
    Modulo: 28,
    TipoEstadoFlujo: 'Descarga',
  },
  { 
    id: 24,
    Nombre: 'Pendiente de aceptación',
    SalidaRegla: 'Descarga',
    Modulo: 28,
    TipoEstadoFlujo: 'Descarga',
  },
  { 
    id: 25,
    Nombre: 'Rechazada urgente',
    SalidaRegla: 'Descarga',
    Modulo: 28,
    TipoEstadoFlujo: 'Descarga',
  },
]

export {
  TIPOS_ESTADO_DESCARGA
}
